import { render, staticRenderFns } from "./mobi-nav-menu.vue?vue&type=template&id=2561287e&scoped=true&"
import script from "./mobi-nav-menu.vue?vue&type=script&lang=js&"
export * from "./mobi-nav-menu.vue?vue&type=script&lang=js&"
import style0 from "./mobi-nav-menu.vue?vue&type=style&index=0&id=2561287e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2561287e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VFlex,VLayout})
